// The signed-in user's onboarding choices (users/{uid}/userSettings/onboarding): which use case they
// picked on /workspace and whether they closed the "get started" panel. null until it loads.
import { useCallback, useEffect, useState } from 'react';
import { doc, onSnapshot, setDoc, serverTimestamp } from 'firebase/firestore';
import { auth, db } from '../../firebase';

export default function useOnboarding() {
  const uid = auth.currentUser?.uid;
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!uid) return undefined;
    return onSnapshot(
      doc(db, 'users', uid, 'userSettings', 'onboarding'),
      snap => setState(snap.data() || {}),
      () => setState({}),
    );
  }, [uid]);

  const update = useCallback(fields => {
    if (!uid) return;
    setState(prev => ({ ...(prev || {}), ...fields }));
    setDoc(doc(db, 'users', uid, 'userSettings', 'onboarding'), { ...fields, updatedAt: serverTimestamp() }, { merge: true }).catch(() => {});
  }, [uid]);

  return [state, update];
}
